import EventBus from '@/eventBus'
import { getFreeSlideUsage } from '@/utils/freeSlideUsage'
import { resolveServedSlideLimits } from '@/utils/slideLimitRuleset'

/**
 * Store-only verdict of the Free question-type Present wall, for entry points that
 * start presenting without the header Present button mounted (the PowerPoint add-in).
 * @param {Object} state root Vuex state
 * @param {Object} getters root Vuex getters
 * @returns {Object|null} the over-limit distinctTypes usage, or null when presenting is allowed
 */
export const getOverDistinctTypeLimit = (state, getters) => {
  const distinctTypeLimitOverride = getters['planModule/distinctTypeLimitOverride']
  if (!distinctTypeLimitOverride) return null
  const presentation = state.presentation || {}
  const servedSlideLimits = resolveServedSlideLimits({
    storedSlideLimits: state.presentationSlideLimits,
    storedPresentationId: state.presentationSlideLimitsPresentationId,
    openPresentationId: presentation.id,
    fallbackSlideLimits: state.planBenefit && state.planBenefit.slideLimits,
    ignoreAllLimits: getters['planModule/shouldIgnoreSlideLimits'],
    distinctTypeLimitOverride,
  })
  const { distinctTypes } = getFreeSlideUsage(presentation.slides || [], state.planBenefitLimitation, servedSlideLimits)
  return distinctTypes && distinctTypes.isOver ? distinctTypes : null
}

/**
 * Stops a not-yet-presenting deck from going live over the Free question-type limit: asks
 * EditorHeader for the wall toast and reports the block. A deck already presenting is never blocked.
 * @param {Object} store Vuex store (or any object with state and getters)
 * @returns {boolean} true when the caller must return before its first write
 */
export const isPresentWalled = (store) => {
  if (store.state.presentation && store.state.presentation.presenting) return false
  if (!getOverDistinctTypeLimit(store.state, store.getters)) return false
  EventBus.$emit('start-presenting-now')
  return true
}
